import { stock } from '@/data/stockImages';

// Hesap (C). Hedef: kafe menü fiyatları nasıl belirlenir, menü fiyatlandırma, kafe fiyat hesaplama.
export default [
  {
    t: 'p',
    text: 'Kafe menü fiyatları çoğunlukla ürün maliyetinden yola çıkılarak belirlenir: ürünün maliyeti, hedeflediğiniz maliyet oranına bölünür, bulunan fiyata KDV eklenir ve sonuç yuvarlanır. Ardından bu fiyat, çevredeki benzer mekânlarla ve işletmenin sabit giderlerini karşılayıp karşılamadığıyla kontrol edilir. Maliyeti bilmeden konulan fiyat, ancak tesadüfen doğru olur.',
  },
  {
    t: 'p',
    text: 'Bu yazıda fiyatı hesaplamanın yollarını, sabit giderlerin nasıl hesaba katılacağını ve fiyatların ne zaman güncellenmesi gerektiğini örneklerle anlatıyoruz. Ürün maliyetini henüz hesaplamadıysanız önce [ürün maliyeti nasıl hesaplanır](/blog/urun-maliyeti-nasil-hesaplanir) yazısına bakmanızı öneririz.',
  },
  { t: 'h2', text: 'Maliyet oranına göre fiyat' },
  {
    t: 'p',
    text: 'En yaygın yöntem budur. Hedef maliyet oranını belirlersiniz (örneğin %25) ve **KDV hariç fiyat = ürün maliyeti ÷ hedef oran** formülüyle fiyatı bulursunuz. Sonra KDV’yi ekleyip menüye yazılacak fiyata yuvarlarsınız.',
  },
  {
    t: 'table',
    head: ['Ürün', 'Maliyet', 'Hedef oran', 'KDV hariç', 'KDV dahil', 'Menü fiyatı'],
    rows: [
      ['Latte', '30,60 TL', '%25', '122,40 TL', '134,64 TL', '135 TL'],
      ['Izgara somon', '233 TL', '%33', '706,06 TL', '776,67 TL', '780 TL'],
    ],
    caption: 'Örnekte KDV %10 alınmıştır. Ürününüze uygulanan güncel oranı mali müşavirinizle teyit edin.',
  },
  {
    t: 'p',
    text: 'Hedef oranın her ürün için aynı olması gerekmez. İçeceklerde maliyet düşük olduğu için oran da düşük tutulabilir; pahalı hammaddeli yemeklerde oranı biraz yüksek tutmak, fiyatın müşteriye makul görünmesini sağlar. Menünün geneline bakıldığında oranın dengeli olması yeterlidir.',
  },
  { t: 'h2', text: 'Sabit giderler fiyatı nasıl etkiler?' },
  {
    t: 'p',
    text: 'Maliyet oranı yöntemi hammaddeyi karşılar, ama kira, personel, faturalar ve abonelikler de her ay ödenir. Fiyatın bunları karşılayıp karşılamadığını görmek için **katkı payına** bakılır: KDV hariç satış fiyatından ürün maliyeti çıkarıldığında kalan tutar.',
  },
  {
    t: 'p',
    text: 'Latte’yi 140 TL’ye sattığınızı düşünelim. KDV hariç fiyat 127,27 TL, maliyet 30,60 TL; her satış 96,67 TL katkı bırakır. Aylık sabit giderleriniz 300.000 TL ise bunları yalnızca latte ile karşılamak için ayda yaklaşık 3.100, günde yaklaşık 103 latte satmanız gerekir.',
  },
  {
    t: 'p',
    text: 'Gerçekte tek ürün satılmaz, ama bu hesap ortalama sepet ve günlük müşteri sayısıyla birlikte düşünüldüğünde işe yarar. Günlük satış adediniz bu seviyeye yaklaşmıyorsa sorun fiyatta, maliyette ya da satış hacminde olabilir; hangisi olduğunu görmek için üçüne birden bakmak gerekir.',
  },
  { t: 'h2', text: 'Çevredeki fiyatlar ve müşteri algısı' },
  {
    t: 'img',
    img: stock('cheesecake', 'Meyveli cheesecake dilimi'),
  },
  {
    t: 'p',
    text: 'Hesapla bulunan fiyat, çevredeki benzer mekânların fiyatlarıyla karşılaştırılmalıdır. Aynı sokaktaki bir kafe latte’yi belirgin şekilde daha ucuza satıyorsa müşteri farkı fark eder; bu durumda fiyatı düşürmek yerine farkı neyin açıkladığını düşünmek gerekir: kahvenin kalitesi, porsiyon, mekânın konumu ya da oturma alanı.',
  },
  {
    t: 'p',
    text: 'Yuvarlamada tutarlılık önemlidir. Menünün bir kısmında 135, bir kısmında 139,90 gibi fiyatlar karışık görünür. Hangi yuvarlama kuralını seçerseniz seçin (5’e, 10’a), menünün tamamında aynı kuralı uygulamak daha düzenli bir görüntü verir.',
  },
  { t: 'h2', text: 'Hangi ürün ne kadar kazandırıyor?' },
  {
    t: 'p',
    text: 'Fiyat belirlemenin bir sonraki adımı, menüdeki ürünleri satış adedi ve katkı payına göre birlikte değerlendirmektir. Bu yaklaşım “menü mühendisliği” olarak bilinir ve ürünleri dört gruba ayırır:',
  },
  {
    t: 'table',
    head: ['', 'Katkı payı yüksek', 'Katkı payı düşük'],
    rows: [
      [
        '**Çok satıyor**',
        'Menünün yıldızları: yerini koruyun',
        'Sevilen ama az kazandıran: maliyeti ya da fiyatı gözden geçirin',
      ],
      [
        '**Az satıyor**',
        'Kazandıran ama fark edilmeyen: menüde öne çıkarın',
        'Az satan ve az kazandıran: menüden çıkarmayı düşünün',
      ],
    ],
  },
  {
    t: 'p',
    text: 'Bu tabloyu doldurmak için ürün bazında satış adedini ve maliyeti bilmek gerekir. Satış raporları ve reçeteli maliyet hesabı birlikte kullanıldığında tablo birkaç dakikada çıkar.',
  },
  {
    t: 'guide',
    image: '15-raporlar',
    alt: 'Raporlar ekranında ürün bazında satış adedi ve en çok kazandıran ürünler',
    caption: 'Satış raporları: ürün bazında adet, ciro ve en çok kazandıran ürünler.',
  },
  { t: 'h2', text: 'Fiyatlar ne zaman güncellenmeli?' },
  {
    t: 'list',
    items: [
      'Bir ürünün ana malzemesinin alış fiyatı belirgin şekilde değiştiğinde.',
      'Maliyet oranı hedeflediğiniz aralığın dışına çıktığında.',
      'Kira, personel ya da enerji gibi sabit giderlerde kalıcı bir artış olduğunda.',
    ],
  },
  {
    t: 'p',
    text: 'Fiyatları sık güncellemek basılı menüde maliyetlidir; QR menüde ise fiyat panelden değiştiği anda menüye yansır. Fiyat değişikliğinde işyeri girişindeki fiyat listesinin de güncellenmesi gerektiğini unutmayın. QR menü hazırlığı için [QR menü nasıl oluşturulur](/blog/qr-menu-nasil-olusturulur) yazısına bakabilirsiniz.',
  },
  { t: 'h2', text: 'Tilki Otomasyon’da fiyat ve maliyet' },
  {
    t: 'p',
    text: 'Tilki’de ürün fiyatı ve KDV oranı ürün ayarlarından girilir; değişiklik kasaya ve QR menüye aynı anda yansır. Reçete tanımlı ürünlerin güncel maliyetini stok ekranındaki “Maliyet” sekmesinde, hangi ürünlerin çok satıp çok kazandırdığını “Raporlar” sayfasında görebilirsiniz.',
  },
  {
    t: 'cta',
    title: 'Fiyatlarınızı maliyetle birlikte görün',
    text: 'Ücretsiz demo talep edin; ürünlerinizin maliyetini ve satış raporlarını birlikte inceleyelim.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Kafede maliyet oranı yüzde kaç olmalı?',
    a: 'Tek bir doğru oran yok. Kafe ve restoranlarda çoğunlukla %25–35 aralığı hedeflenir; içeceklerde oran genellikle daha düşük, yemeklerde daha yüksek çıkar. Önemli olan her ürünün oranını bilmek ve menünün genelinde dengeyi korumaktır.',
  },
  {
    q: 'Fiyatı maliyetin katı olarak belirlemek doğru mu?',
    a: 'Maliyetin 3 ya da 4 katı gibi kurallar hızlı bir başlangıç verir, ama her ürüne aynı katı uygulamak pahalı hammaddeli ürünleri çok yükseltir, ucuz olanları ise gereğinden düşük fiyatlar. Maliyet oranını ürün grubuna göre belirlemek daha dengeli sonuç verir.',
  },
  {
    q: 'Menüde KDV dahil mi, hariç mi fiyat yazılır?',
    a: 'Tüketiciye sunulan fiyat listelerinde vergiler dahil satış fiyatının gösterilmesi gerekir. Hesaplamaları KDV hariç fiyat üzerinden yapıp menüye KDV dahil fiyatı yazmak, karışıklığı önler.',
  },
];
